'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

let _ = t => t,
    _t;

import { useMemo, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Footer } from 'marketing-dot-com-nav';
import { createGlobalStyle } from 'styled-components';
import { MAIN_SECTION_MAX_WIDTH, MAIN_SECTION_PADDING_X } from '../../constants/layout';
const GlobalFooterStyle = createGlobalStyle(_t || (_t = _`
  .hsg-footer__layout {
    max-width: ${0}px !important;
    padding: 0 !important;

    @media (min-width: 768px) {
      padding: 0 ${0}px !important;
    }
  }
`), MAIN_SECTION_MAX_WIDTH, MAIN_SECTION_PADDING_X);

const MarketingNavFooter = ({
  lang
}) => {
  const FooterComponent = useMemo(() => {
    if (lang === 'ja') {
      return Footer.jp;
    }

    return Footer[lang] || Footer.en;
  }, [lang]);
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(GlobalFooterStyle, {}), /*#__PURE__*/_jsx(FooterComponent, {})]
  });
};

MarketingNavFooter.propTypes = {
  lang: PropTypes.string
};
MarketingNavFooter.defaultProps = {
  lang: 'en'
};
export default MarketingNavFooter;